/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderDto } from '../../models/order-dto';
import { OrderRefundDto } from '../../models/order-refund-dto';

export interface OrderControllerCompleteRefund$Params {

/**
 * 주문 ID
 */
  id: string;
      body: OrderRefundDto
}

export function orderControllerCompleteRefund(http: HttpClient, rootUrl: string, params: OrderControllerCompleteRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerCompleteRefund.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderDto>;
    })
  );
}

orderControllerCompleteRefund.PATH = '/api/orders/{id}/complete-refund';
